import { ChevronRight } from 'lucide-react'
import type { Recipe } from '@hewey/shared'
import { RecipeCard } from './RecipeCard.tsx'
import styles from './CollectionRow.module.css'

type Props = {
	title: string
	subtitle?: string | undefined
	recipes: Recipe[]
	onSeeAll?: (() => void) | undefined
}

// One Explore collection: a heading (with optional "See all" hand-off into the
// results grid) above a single horizontally-scrolling row of feature cards.
export const CollectionRow = ({
	title,
	subtitle,
	recipes,
	onSeeAll,
}: Props) => (
	<section className={styles.row}>
		<header className={styles.head}>
			<div className={styles.heading}>
				<h2 className={styles.title}>{title}</h2>
				{subtitle ? (
					<p className={styles.subtitle}>{subtitle}</p>
				) : null}
			</div>
			{onSeeAll ? (
				<button
					type="button"
					className={styles.seeAll}
					onClick={onSeeAll}
				>
					See all
					<ChevronRight size={16} aria-hidden="true" />
				</button>
			) : null}
		</header>

		<ul className={styles.scroll}>
			{recipes.map((r) => (
				<li key={r.id} className={styles.item}>
					<RecipeCard recipe={r} taggingFresh={false} />
				</li>
			))}
		</ul>
	</section>
)
